// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"94b51c8b","355":"0417ecae","455":"8a8f788a","515":"dd8a32bf","929":"f4facb83","977":"d6324889","994":"a8247620"}[chunkId] + ".chunk.js";
};